import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    // Should be published with the design-tokens: https://prisma.atlassian.net/browse/UXX-703
    theme: {
      spacing: [
        '0',
        '2xs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        '7xl',
      ],
      radius: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl'],
    },
    classGroups: {
      'font-family': [
        'font-family-headline',
        'font-family-title',
        'font-family-body',
        'font-family-label',
      ],
      'font-size': [
        'text-legacy-base',
        'text-legacy-xs',
        'text-headline-lg',
        'text-headline-md',
        'text-title-md',
        'text-title-sm',
        'text-body-lg',
        'text-body-md',
        'text-body-sm',
        'text-body-base',
        'text-label-lg',
        'text-label-md',
        'text-label-sm',
        'text-label-base',
      ],
      'font-weight': [
        'font-headline',
        'font-title',
        'font-body-regular',
        'font-body-italic',
        'font-body-semibold',
        'font-label-regular',
        'font-label-italic',
        'font-label-semibold',
        'font-legacy-bold',
      ],
    },
  },
});

/**
 * Combines multiple class names or conditional class names and merges Tailwind CSS classes efficiently.
 * See https://ayberkyavas.com/blogs/wtf-is-clsx-twmerge-cn-in-tailwindcss or https://www.reddit.com/r/tailwindcss/comments/1egbuvx/the_buzz_around_cn_function_and_why_do_we_use_it/
 * for more information.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(...classes));
}
